import React from 'react';
import { Clock, AlertTriangle } from 'lucide-react';
export function UrgencySection() {
  return <section className="py-10 bg-white border-y border-gray-100" data-id="element-268">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center" data-id="element-269">
        <div className="inline-flex items-center gap-2 text-red-600 font-bold mb-4" data-id="element-270">
          <Clock className="w-5 h-5 animate-pulse" data-id="element-271" />⏰ PRECIO DE LANZAMIENTO —
          CIERRA PRONTO
        </div>

        <div className="flex items-center justify-center gap-2 text-sm font-medium text-gray-600 bg-gray-50 py-2 px-4 rounded-full w-fit mx-auto" data-id="element-272">
          <AlertTriangle className="w-4 h-4 text-accent-orange" data-id="element-273" />
          Después sube. No vuelve.
        </div>
      </div>
    </section>;
}